import "./App.css";
import { GoogleReCaptchaProvider } from "react-google-recaptcha-v3";
import { Home } from "./Screens";
import "react-responsive-carousel/lib/styles/carousel.min.css";

function App() {

  console.log(process.env.REACT_APP_RECAPTCHA_SITE_KEY)
  return (
    <>
      <GoogleReCaptchaProvider
        // @ts-ignore
        reCaptchaKey={process.env.REACT_APP_RECAPTCHA_SITE_KEY}
        scriptProps={{
          async: false,
          defer: false,
          appendTo: "head",
          nonce: undefined,
        }}
      >
        <Home />
      </GoogleReCaptchaProvider>
    </>
  );
}

export default App;
